import { OWebPageBase } from "oweb";
import PUserPassEditComponent from "@/components/pages/oweb/PUserPassEdit.vue";
import { VueConstructor } from 'vue';

export default class PUserPassEdit extends OWebPageBase<VueConstructor> {
	getName() {
		return "PUserPassEdit"
	}

	getRoutes() {
		return [ {
			title: "OO_LANG_PASS_EDIT",
			path: "/me/edit/pass"
		} ]
	}

	requireLogin() {
		return true
	}

	getComponent() {
		return PUserPassEditComponent;
	}
}